import { RequestIdTableCell } from '../../components/utilities/Table/RequestIdTableCell';

const commonColumns = [
    {
        Header: () => 'Solución financiera',
        id: 'id_solution',
        typeId: 'HeaderRequest',
        Cell: ({ row }) => {
            //:id_financial_solution/:id_persona/:id_solicitud
            return (
                <RequestIdTableCell
                    row={row}
                    url={`process/${row.original.id}/${row.original.persona.pk}/${row.original.solicitud_id}`}
                    idRoute={row.original.id}
                />
            );
        },
    },
    {
        Header: 'Fecha creación',
        accessor: 'created_at',
    },
    {
        Header: 'Tipo',
        accessor: 'tipo_solucion_financiera.label',
    },
    {
        Header: 'Nro crédito',
        accessor: 'num_credito',
    },
    {
        Header: 'Identificación',
        accessor: 'persona.numero_identificacion',
    },
    {
        Header: 'Cliente',
        accessor: 'persona.full_name',
        typeId: 'HeaderClient',
    },
    {
        Header: 'Producto',
        accessor: 'subproducto.label',
    },
    {
        Header: 'Oficina',
        accessor: 'oficina.label',
    },
    {
        Header: 'Ejecutivo',
        accessor: 'ejecutivo.name',
    },
    {
        Header: 'Estado',
        accessor: 'estado.label',
    },
];

const ColumnsCartera = [
    {
        Header: 'Nro crédito',
        accessor: 'num_credito',
    },
    {
        Header: 'Identificación',
        accessor: 'numero_identificacion_cliente',
    },
    {
        Header: 'Cliente',
        accessor: 'nombre_cliente',
        typeId: 'HeaderClient',
    },
    {
        Header: 'Producto',
        accessor: 'linea_credito',
    },

    {
        Header: 'Oficina',
        accessor: 'oficina',
    },
    {
        Header: 'Días mora',
        accessor: 'dias_mora',
    },
    {
        Header: 'Ejecutivo',
        accessor: 'nombre_ejecutivo',
    },
];

const requestsFinancialSolutionsStatus = [
    {
        id: 'cartera',
        label: 'CARTERA',
        offices: true,
        columns: ColumnsCartera,
        registrationLimit: 5,
        buttonAction: [{ name: 'takeCreditFinancialSolutions' }],
        apiSolicitud: true,
    },
    {
        id: 'en_proceso',
        label: 'EN PROCESO',
        status: '1',
        offices: true,
        responsable: true,
        columns: commonColumns,
        registrationLimit: 5,
        apiSolicitud: false,
    },
    {
        id: 'procesadas',
        label: 'PROCESADAS',
        status: '',
        responsable: false,
        offices: true,
        columns: commonColumns,
        registrationLimit: 5,
        apiSolicitud: false,
        nameColumnProcessed: [
            {
                name: 'usuario_creacion_gestion',
                value: 'user',
                operator: '|',
            },
            {
                name: 'usuario_desistimiento',
                value: 'user',
                operator: '|',
            },
            {
                name: 'usuario_rechazo',
                value: 'user',
                operator: '|',
            },
        ],
    },
];
export default requestsFinancialSolutionsStatus;
